import { render, staticRenderFns } from "./SelectImageDialog.vue?vue&type=template&id=ed612416&scoped=true"
import script from "./SelectImageDialog.vue?vue&type=script&lang=js"
export * from "./SelectImageDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectImageDialog.vue?vue&type=style&index=0&id=ed612416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed612416",
  null
  
)

export default component.exports